import { RouteLink } from "../../RouteLink";
import routes from "../../../utils/routes";
import {slugifyText} from "../../../utils/slugifyText";
import RadioCss from "../Style.module.scss";
import {LogoPlayerRow} from "../Image/LogoPlayerRow";
import {useRef} from "react";
import {FlowText} from "../../FlowText";

export const EpisodePlayerRow = (props: {
    className?: string,
    episode: PlayedItemType,
}) => {

    const a = useRef<HTMLAnchorElement|null>(null);
    const episode = "id" in props.episode ? props.episode : null;
    if (!episode)
        return null;
    let radio:string|null = null;
    if ("radioName" in episode) {
        radio = episode.radioName as string;
    }
    
    const name = episode.name;
    const url = (() => {
        if ("radioSlug" in episode)
            return routes.radio_program_detail_episode(episode.radioSlug as string, episode.programSlug, `${episode.id}`, slugifyText(episode.name));
        return routes.program_detail_episode(episode.programSlug, `${episode.id}`, slugifyText(episode.name))
    })();

    return <>
        <RouteLink ref={a} to={url} className={`${props.className ?? ""} ${RadioCss.LinkRow} ${RadioCss.PlayerRow} d-flex flex-row align-items-start overflow-hidden d-position-relative`}>
            <LogoPlayerRow src={episode.image} alt={name} className={`align-self-center ${RadioCss.LogoRow}`}   />
            <div className="align-self-center" >
                {radio ? <FlowText text={radio} parent={a} className={RadioCss.nameRadio} /> : null}
                <FlowText text={episode.programName} parent={a} className={RadioCss.nameProgram} />
                <FlowText text={episode.name} parent={a} className={RadioCss.nameSpan} />
            </div>
        </RouteLink>
    </>
}
